import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { ConnectionAuthKind, ConnectionKind } from 'shell-models-lib';
import { DataSourceOptionKind } from '@powerquery/mashup-editor-client';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

export const sapBdcMetadata: ILinkedServiceTypeMetadata = {
    type: adfModelTypeMap.sapBdc.linkedServiceType,
    displayName: stringResources.Mirror_SAP_BDC_Inbound_header,
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-Sap'
    },
    category: ['Database'],
    copySourceTypes: [],
    copySinkTypes: [],
    supportedInTrident: true,
    supportedAuthKindsInTrident: [ConnectionAuthKind.OAuth2, ConnectionAuthKind.ServicePrincipal],
    notShowInTypeSelection: true,
    onetimeQueryTemplate: '',
    timedQueryTemplate: '',
    pqoDataSourceOption: {
        kind: DataSourceOptionKind.Extension,
        resourceKind: ConnectionKind.SAP_BUSINESS_DATA_CLOUD
    }
};
